import React, { useEffect, useState } from "react";
import footerImg from "../../Assest/Images/footerbgnew.svg";
import { Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import { Facebook, YouTube, LinkedIn } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import colors from "../../Assest/Theme/Color";
import footerLogo from "../../Assest/Images/footornewlogo.svg";
import useTranslations from "../Translations/useTranslations";
import { fetchData } from "../../BaseUrl";

function Footer() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTab = useMediaQuery("(max-width:1024px)");
  const { translations, languageSelect } = useTranslations();
  const [socialLinks, setSocialLinks] = useState({});

  useEffect(() => {
    fetchData("admin/website-config/list")
      .then(res => {
        const arr = Array.isArray(res?.data) ? res.data : [];
        const links = {};
        arr.forEach(c => { links[c.configKey] = c.configValue; });
        setSocialLinks(links);
      })
      .catch(() => {});
  }, []);
  const styles = {
    container: {
      background: isMobile ? colors.footerBgColor : `url(${footerImg})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      minHeight: isTab ? "40vh" : "70vh",
      width: "100%",
      height: "100%",
      textAlign: isMobile ? "center" : "left",
    },

    heading: {
      fontSize: languageSelect === "Tamil" ? "16px" : "18px",
      fontWeight: "bold",
      color: colors.footerColor,
      marginBottom: "10px",
    },
    subheading: {
      fontSize: languageSelect === "Tamil" ? "16px" : "15px",
      color: colors.footerColor,
      marginBottom: "10px",
      textAlign:'justify'
    },
    contentCeter: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#ffff!important",
    },
  };

  const handleredirecturl=(url)=>
  {
    window.open(url,"_blank")
  }
  return (
    <div>
      <div style={{ ...styles.container, ...styles.contentCeter }}>
        <Grid
          container
          spacing={4}
          mt={isMobile ? 0 : 18}
          sx={{ padding: "0 3rem" }}
        >
          <Grid item xs={12} sm={4} style={styles.contentCeter}>
            <div>
              <img
                src={footerLogo}
                alt="footerLogo"
                style={{
                  marginTop: isMobile ? "" : "-3rem",
                  marginBottom: "1rem",
                  width: isMobile ? "60%" : "60%",
                }}
              />
              {/* <Typography style={styles.subheading}>
                {" "}
                <CallIcon sx={{ mb: -0.4, mr: 0.4 }} /> (303) 555-0105
              </Typography> */}
              <Typography style={styles.subheading}>
                {" "}
                <EmailIcon sx={{ mb: -0.4, mr: 0.4 }} />{" "}
                contact@cummingtamilschool.org
              </Typography>
              {/* <Typography style={styles.subheading}>
                <FmdGoodIcon sx={{ mb: -0.4, mr: 0.6 }} />
                <span>Big Creek Elementary School, 1994 </span>
                <span> Peachtree Pkwy, Cumming, GA 30041</span>
              </Typography> */}
              <Typography component="div" style={styles.subheading}>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <FmdGoodIcon style={{ marginRight: 8, marginTop: 4 }} />
                  <div>
                    <div>Big Creek Elementary School,</div>
                    <div>1994 Peachtree Pkwy, Cumming, GA 30041</div>
                  </div>
                </div>
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} style={styles.contentCeter}>
            {/* <div>
              <Typography style={styles.heading}>
                {translations.quickLinks}
              </Typography>
              <Typography style={styles.subheading}>
                {" "}
                {translations.privacyPolicy}
              </Typography>
              <Typography style={styles.subheading}>
                {translations.termsOfService}
              </Typography>
              <Typography style={styles.subheading}>
                {translations.faqs}
              </Typography>
            </div> */}
          </Grid>
          <Grid item xs={12} sm={4} style={styles.contentCeter}>
            <div>
              <Typography style={styles.heading}>
                {" "}
                {translations.socialMedia}
              </Typography>
              <Grid
                container
                sx={
                  isMobile
                    ? {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }
                    : {}
                }
              >
                <Grid xs={4}>
                  <IconButton size="small" onClick={() => handleredirecturl(socialLinks.facebook_url || colors.Facebookurl)}>
                    <Facebook sx={{ color: colors.footerColor }} />
                  </IconButton>
                </Grid>
                <Grid xs={4}>
                  <IconButton size="small" onClick={() => handleredirecturl(socialLinks.instagram_url || colors.instaurl)}>
                    <InstagramIcon sx={{ color: colors.footerColor }} />
                  </IconButton>
                </Grid>
                <Grid xs={4}>
                  <IconButton size="small" onClick={() => handleredirecturl(socialLinks.youtube_url || colors.YouTubeurl)}>
                    <YouTube sx={{ color: colors.footerColor }} />
                  </IconButton>
                </Grid>
                {(socialLinks.twitter_url || socialLinks.linkedin_url) && (
                  <>
                    {socialLinks.twitter_url && (
                      <Grid xs={4}>
                        <IconButton size="small" onClick={() => handleredirecturl(socialLinks.twitter_url)}>
                          <XIcon sx={{ color: colors.footerColor }} />
                        </IconButton>
                      </Grid>
                    )}
                    {socialLinks.linkedin_url && (
                      <Grid xs={4}>
                        <IconButton size="small" onClick={() => handleredirecturl(socialLinks.linkedin_url)}>
                          <LinkedIn sx={{ color: colors.footerColor }} />
                        </IconButton>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div
              style={{
                textAlign: "center",
                color: colors.footerSubText,
                borderTop: "1px solid #FFFFFF",
                padding: "10px",
                
              }}
            >
              <Typography sx={{opacity:0.7}}>
                Powered by{" "}
                <a
                  href="https://www.keelis.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: colors.footerSubText }}
                >
                  keelis
                </a>
              </Typography>
              <Typography sx={{opacity:0.7}}>
                © 2025, Cumming Tamil School All Rights Reserved.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Footer;
